<template>
  <div>
    <a-modal :title="title" :visible="visible" :confirm-loading="confirmLoading" @cancel="handleCancel" :width="620">
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="submit" type="primary" @click="handleOk" v-if="!disabled">确认</a-button>
      </template>
      <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="{ span: 7 }" :wrapper-col="{ span: 17 }">
        <a-form-model-item label="框架合同编号:" prop="contractNo">
          <a-input v-model="form.contractNo" :disabled="disabled" style="width:220px;" />
        </a-form-model-item>
        <a-form-model-item label="卖方名称:" prop="sellrOrgCode">
          <a-select v-model="form.sellrOrgCode" placeholder="请选择" :disabled="disabled" style="width:220px;"
            v-if="type === '1'">
            <a-select-option v-for="item in sellOptions" :key="item.orgCode" :value="item.orgCode">{{item.userName}}
            </a-select-option>
          </a-select>
          <a-select show-search v-model="form.sellrOrgCode" placeholder="请输入" style="width: 220px"
            :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null"
            @search="selectSellerName" v-if="type === '2'" :disabled="disabled">
            <a-select-option v-for="item in sellList" :key="item.orgCode" :value="item.orgCode">{{item.userName }}
            </a-select-option>
          </a-select>
          <a-radio-group v-model="type" style="width:150px;margin-left:20px;" @change="typeChange" :disabled="disabled">
            <a-radio value="1">圈子</a-radio>
            <a-radio value="2">键入</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="附件上传:" prop="fileId">
          <fileUpload accept=".png, .PNG, .jpg, .JPG, .jpeg, .JPEG, .pdf, .PDF" ref="fileUpload" :showList="[file]"
            :paramObj="uploadParam" @uploadOk="uploadOk" @remove="removeOk" :disabled="disabled" name="file" />
          <span style="color:red;" v-if="!disabled">请上传png、jpg、jpeg、pdf格式的文件</span>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { selectSellerCstByName } from '@/api/payable.js'
import { selectSellerCst } from '@/api/rcvbBuy.js'
import { fileSaveAPI } from '@/api/file.js'
import { contractAdd } from '@/api/contract.js'
import _ from "underscore"

export default {
  data() {
    return {
      title: '新增合同',
      visible: false,
      confirmLoading: false,
      disabled: false,
      uploadParam: {
        app: 'portal-pc',
        module: 'contract',
        user: this.$store.getters['home/getUserHeader'].realname,
        tblBlId: this.utils.guid(32, 16),
        mdlId: 'contract',
      },
      file: null,
      type: '1',
      form: {
        contractNo: undefined,
        fileId: undefined,
        sellrName: undefined,
        sellrOrgCode: undefined,
        buryOrgCode: this.$store.getters['home/getUserObj'].orgCode,
      },
      sellOptions: [],
      sellList: [],
      rules: {
        contractNo: [
          {
            required: true,
            message: '请输入框架合同编号',
            trigger: 'blur',
          },
        ],
        sellrOrgCode: [
          {
            required: true,
            message: '请选择卖方名称',
          },
        ],
        fileId: [
          {
            required: true,
            message: '请上传附件',
          },
        ],
      },
    }
  },
  methods: {
    open(row, flag) {
      this.disabled = flag || false
      if (row) {
        this.title = !flag ? '修改框架合同' : '框架合同详情'
        this.file = row.fileMap
        this.form.id = row.id
        this.form.contractNo = row.contractNo
        this.form.fileId = row.fileId
        this.form.sellrOrgCode = row.sellrOrgCode
        this.form.buryOrgCode = row.buryOrgCode
        this.getSell().then(res => {
          let item = this.sellOptions.find(item => item.orgCode == this.form.sellrOrgCode)
          if (item) {
            this.type = '1'
          } else {
            this.type = '2'
            this.sellList = [{
              orgCode: row.sellrOrgCode,
              userName: row.sellrName
            }]
          }
        })
      } else {
        this.type = '1'
        this.title = '新增框架合同'
        this.file = undefined
        this.form.id = undefined
        this.form.contractNo = undefined
        this.form.fileId = undefined
        this.form.sellrOrgCode = undefined
        this.form.buryOrgCode = this.$store.getters['home/getUserObj'].orgCode
        this.getSell()
      }
      this.visible = true
    },
    getSell() {
      return new Promise((resolve, reject) => {
        selectSellerCst({
          pageSize: 10,
          effStCd: 1,
          statusCode: 0,
          state: 2,
          userName: '',
          pageNum: 1,
        })
          .then((res) => {
            this.sellOptions = res.data.grid.list
            resolve()
          })
          .catch((error) => {
            reject()
            console.log(error)
          })
      })

    },
    fileSave(data) {
      const param = {
        fileNm: data.name,
        fileSize: data.size,
        fileRte: data.fileRte,
        fileExpdNm: data.fileExpdNm,
        tblBlId: this.uploadParam.tblBlId,
        mdlId: 'contract',
      }
      fileSaveAPI(param)
        .then((res) => {
          this.form.fileId = res.data.fileId
          this.file = data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    uploadOk(resList) {
      this.fileSave(resList[0])
    },
    removeOk() {
      this.file = null
      this.form.fileId = undefined
    },
    typeChange() {
      this.sellList = [];
      this.form.sellrOrgCode = undefined
    },
    selectSellerName: _.throttle(function (value) {
      selectSellerCstByName({
        userName: value,
      }).then((res) => {
        if (res.data) {
          this.sellList = res.data.grid.list
        } else {
          return false
        }
      })
        .catch((err) => { })
    }, 1000, { leading: false }),
    handleOk(e) {
      this.confirmLoading = true
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          contractAdd(this.form)
            .then((res) => {
              this.$emit('success')
              this.$message.success('保存成功')
              this.handleCancel()
              this.confirmLoading = false
            })
            .catch(() => {
              this.confirmLoading = false
            })
        } else {
          this.confirmLoading = false
          return false
        }
      })
    },
    handleCancel(e) {
      this.file = null
      this.form.fileId = undefined
      this.$refs.ruleForm.resetFields()
      this.visible = false
    },
  },
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/bill-manage/contract/AddPage.vue